module.exports = __webpack_public_path__ + "confetti-mobile___38HbU.svg";